module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    ref: "menuWrapper",
    staticClass: "menu-wrapper"
  }, [_c('ul', _vm._l((_vm.goods), function(item, index) {
    return _c('li', {
      staticClass: "menu-item",
      class: {
        'current': parseInt(index) === _vm.currentIndex
      },
      on: {
        "click": function($event) {
          _vm.selectMenu(index, $event)
        }
      }
    }, [_c('span', {
      staticClass: "text border-1px"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type > 0),
        expression: "item.type>0"
      }],
      staticClass: "icon",
      class: _vm.classMap[item.type]
    }), _vm._v(_vm._s(item.name) + "\n        ")])])
  }))]), _vm._v(" "), _c('div', {
    ref: "foodsWrapper",
    staticClass: "foods-wrapper"
  }, [_c('ul', _vm._l((_vm.goods), function(item) {
    return _c('li', {
      staticClass: "food-list food-list-hook"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('ul', _vm._l((item.foods), function(food) {
      return _c('li', {
        staticClass: "food-item border-1px"
      }, [_c('div', {
        staticClass: "icon",
        on: {
          "click": function($event) {
            _vm.selectFood(food, $event)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": food.icon,
          "alt": "",
          "width": "57",
          "height": "57"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('h2', {
        staticClass: "name"
      }, [_vm._v(_vm._s(food.name))]), _vm._v(" "), _c('p', {
        staticClass: "desc"
      }, [_vm._v(_vm._s(food.description))]), _vm._v(" "), _c('div', {
        staticClass: "extra"
      }, [_c('span', {
        staticClass: "count"
      }, [_vm._v(_vm._s(_vm.$t('sellcount')) + _vm._s(food.sellCount) + _vm._s(_vm.$t('qtys')))]), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (food.rating),
          expression: "food.rating"
        }]
      }, [_vm._v(_vm._s(_vm.$t('rating')) + _vm._s(food.rating) + "%")])]), _vm._v(" "), _c('div', {
        staticClass: "price"
      }, [_c('span', {
        staticClass: "now"
      }, [_vm._v(_vm._s(food.price) + " €")]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (food.oldPrice),
          expression: "food.oldPrice"
        }],
        staticClass: "old"
      }, [_vm._v(_vm._s(food.oldPrice) + " €")])]), _vm._v(" "), _c('div', {
        staticClass: "cartcontrol-wrapper"
      }, [_c('cartcontrol', {
        attrs: {
          "food": food
        },
        on: {
          "cartAdd": _vm.addFood
        }
      })], 1)])])
    }))])
  }))]), _vm._v(" "), _c('shopcart', {
    ref: "shopcart",
    attrs: {
      "selectFoods": _vm.selectFoods,
      "deliveryPrice": _vm.seller.deliveryPrice,
      "min-price": _vm.seller.minPrice
    }
  }), _vm._v(" "), _c('food', {
    ref: "food",
    attrs: {
      "food": _vm.selectedFood
    },
    on: {
      "cartAdd": _vm.addFood
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32c579da","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/goods/goods.vue
// module id = 462
// module chunks = 1